// components
import GridPageAbstract from '../GridPageAbstract';
import { DollarCircleBulkIcon } from '../../icons-lib/bulkIcons';
import config from '../../config';

export default class CoinsPage extends GridPageAbstract {
    constructor(props) {
        super(props);

        this.Name = 'coins';
        this.Server = this.props.context.getState().server.coins;

        this.headerStartIcon = DollarCircleBulkIcon;
        this.bannerImage = config?.bannerImages?.transactions || '';

        this.searchFields = [
            'name',
            'ownerWalletNumber',
            // 'cashoutWallet',
            'partner.name'
        ];

        this.hiddenColumns = config?.hiddenColumns?.coins || [];

        this.Head = [
            {
                id: 'coinLogoFilesId',
                label: 'logo',
                alignRight: false,
                cell: 'Upload',
                object: 'coinLogoFile',
                fileType: 'partner',
                fileParent: 'partnersId',
                uploadType: 'single',
                disableInputFileType: true
            },
            { id: 'name', label: 'name', alignRight: false, cell: 'Text' },
            {
                id: 'ownerWalletNumber',
                label: 'ownerWallet',
                alignRight: false,
                cell: 'Text',
            }, // check cell
            {
                id: 'cashoutWalletId',
                label: 'cashoutWallet',
                alignRight: false,
                cell: 'Text'
            }, // check cell
            {
                id: 'allowMinting',
                label: 'allowMinting',
                alignRight: false,
                cell: 'Checkbox',
                trueLabel: 'allow',
                falseLabel: 'deny',
                type: 'boolean',
                filterCell: 'Boolean'
            },
            {
                id: 'campaignEndDate',
                label: 'campaignEndDate',
                alignRight: false,
                cell: 'Date',
                disableEditor: true
            },
            {
                id: 'claimDeadline',
                label: 'claimDeadline',
                alignRight: false,
                cell: 'Date',
                disableEditor: true
            },
            {
                id: 'startingCapital',
                label: 'startingCapital',
                alignRight: false,
                cell: 'Text',
                disableEditor: true
            },
            {
                id: 'maxClaims',
                label: 'maxClaims',
                alignRight: false,
                cell: 'Text'
            },
            {
                id: 'maxSingleTx',
                label: 'maxSingleTx',
                alignRight: false,
                cell: 'Amount',
            },
            {
                id: 'maxWalletCoins',
                label: 'maxWalletCoins',
                alignRight: false,
                cell: 'Amount',
            },
            {
                id: 'maxWalletMonthlyTx',
                label: 'maxWalletMonthlyTx',
                alignRight: false,
                cell: 'Amount',
            },
            {
                id: 'maxWalletYearlyTx',
                label: 'maxWalletYearlyTx',
                alignRight: false,
                cell: 'Amount',
            },
            {
                id: 'isPublic',
                label: 'isPublic',
                alignRight: false,
                cell: 'Checkbox',
                trueLabel: 'public',
                falseLabel: 'private',
                type: 'boolean',
                filterCell: 'Boolean'
            },
            {
                id: 'payoutAccountId',
                label: 'payoutAccount',
                alignRight: false,
                cell: 'Select',
                from: 'payoutAccounts',
                display: 'name',
                object: 'payoutAccount'
            },
            {
                id: 'partnersId',
                sortField: 'partner.name',
                object: 'partner',
                display: 'name',
                label: 'partner',
                alignRight: false,
                cell: 'Select',
                from: 'partners',
                filterBy: 'partners',
                filterCell: 'Context'
            },
            {
                id: 'decimals',
                label: 'decimals',
                alignRight: false,
                cell: 'Text'
            },
            {
                id: 'coinColor',
                label: 'coinColor',
                alignRight: false,
                cell: 'Theme',
                controller: 'coins'
            },
            {
                id: 'dateCreated',
                label: 'dateCreated',
                alignRight: false,
                cell: 'Date',
                filterCell: 'Date',
                disableEditor: true
            },
            {
                id: 'dateModified',
                label: 'dateModified',
                alignRight: false,
                cell: 'Date',
                filterCell: 'Date',
                disableEditor: true
            }
        ].filter((it) => !this.hiddenColumns.includes(it.id));
    }
    customRetrieveData = async (list) => {
        const files = list.map((item) => item.coinLogoFile);
        await this.preloadContextImages(files);
    };
}
